import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nuovo ristorante',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Nuova demo',
        [CompanyCreationModes.full]: 'Nuovo ristorante',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Info ristorante',
        [CompanyCreationSteps.BusinessInfo]: 'Info aziendali',
        [CompanyCreationSteps.AdditionalLocations]: 'Ristoranti aggiuntivi',
      },
    },
    business_profile: {
      legal_info: 'Info legali',
      owner_info: 'Info proprietario',
    },
    recently_created: 'Creati di recente',
  },
  form: {
    franchise: {
      label: 'Crea ristorante',
      tooltip:
        'Seleziona se stai creando un marchio completamente nuovo o aggiungendo questo ristorante a un marchio già esistente nel nostro sistema.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Crea un nuovo marchio',
          tooltip: 'Partiamo da zero — nessun marchio o ristorante esistente',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Aggiungi questo ristorante a un marchio esistente',
          tooltip: 'Appartiene a un marchio già presente nel sistema',
        },
      },
    },
    restaurants: {
      label: 'Ristorante/i associato/i',
    },

    business_profile: {
      label: 'Chi è il proprietario?',
      tooltip:
        'Questo ristorante appartiene a un proprietario/azienda già presente nel sistema (es. «Luís Pizza GmbH»)? <br/> In caso affermativo, seleziona il profilo esistente. Altrimenti, crea un nuovo profilo proprietario/azienda.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Crea nuovo profilo proprietario/azienda',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Usa profilo proprietario/azienda esistente',
      },
    },
    business_type: {
      label: 'Tipo di azienda',
      placeholder: 'Seleziona tipo di azienda',
      options: {
        [BusinessType.Company]: 'Azienda',
        [BusinessType.Individual]: 'Imprenditore individuale',
      },
    },
    display_name: {
      label: 'Nome del ristorante',
      placeholder: 'Nome visualizzato',
    },
    legal_name: {
      label: 'Ragione sociale',
      placeholder: 'Ragione sociale',
    },
    owner_first_name: {
      label: 'Nome del referente',
      placeholder: 'James',
    },
    owner_last_name: {
      label: 'Cognome del referente',
      placeholder: 'Bond',
    },
    owner_phone_number: {
      label: 'Telefono del referente',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Email del referente',
      placeholder: 'Inserisci email',
    },
    password: {
      label: 'Password',
      placeholder: 'Inserisci password',
    },

    additional_companies: {
      label: 'Ristoranti aggiuntivi sotto questo marchio',
      tooltip:
        'Ci sono altri ristoranti sotto lo stesso marchio di {{company}}? <br/> In caso affermativo, clicca «Aggiungi ristorante» per includere altre sedi. Se è lo stesso proprietario ma un marchio diverso, non aggiungere qui. Crealo separatamente.',
    },
  },
  labels: {
    create_demo: 'Crea demo',
    create_company: 'Crea ristorante',
    business_type: 'Tipo di azienda',
    display_name: 'Nome visualizzato',
    legal_name: 'Ragione sociale',
    owner_name: 'Nome proprietario',
    address: 'Indirizzo',
  },
  fields: {
    name: 'Nome',
    created_at: 'Creato',
    actions: 'Azioni',
  },

  buttons: {
    add_restaurant: '+ Aggiungi ristorante',
    continue: 'Continua',
    back: 'Indietro',
    create: 'Crea ristorante',
    delete: 'Elimina',
  },
  popups: {
    delete_demo: {
      title: "Confermare l'eliminazione?",
    },
  },
  toasts: {
    company_created: 'Ristorante creato con successo',
    failed_to_create_company: 'Creazione ristorante fallita',
    failed_to_delete_demo: 'Eliminazione demo fallita',
    demo_got_deleted: 'Demo eliminata con successo',
    failed_to_load_recently_created_companies: 'Caricamento ristoranti creati di recente fallito',
  },
};
